/* custom-scroll-reveal.js — lightweight scroll-triggered reveal animations.
   IntersectionObserver only (no scroll listeners, no layout thrash); each
   element/group animates once then is left alone. Respects
   prefers-reduced-motion via the CSS guard in custom.css — this script only
   toggles a class, the actual motion (and whether there IS motion) lives in
   CSS. Usage:
     data-reveal="fade-up"  — element itself fades up
     data-reveal="zoom"     — a clipped media wrapper; its img/svg zooms out
     data-reveal="stagger"  — each direct child fades up with an incremental
                               delay (e.g. a grid/track of cards). Children
                               added later (e.g. infinite-scroll pagination)
                               are picked up automatically.

   Stagger delays are counted within each batch of children that come into
   view together (one row, one screenful), not from the start of the list,
   so tile 100 of a long grid appears as quickly as tile 1. The step is
   capped so a large first screenful never waits more than ~0.8s.
*/
(function () {
  var STAGGER_STEP_MS = 110;
  var STAGGER_MAX_STEPS = 7;

  var revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        function (entries, obs) {
          var batchIndex = 0;
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (entry.target.hasAttribute('data-reveal-child-init')) {
                var step = Math.min(batchIndex, STAGGER_MAX_STEPS);
                entry.target.style.setProperty('--reveal-delay', step * STAGGER_STEP_MS + 'ms');
                batchIndex += 1;
              }
              entry.target.classList.add('is-revealed');
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
      )
    : null;

  /** @param {Element} el */
  function observe(el) {
    if (!revealObserver) {
      el.classList.add('is-revealed');
      return;
    }
    var obs = revealObserver;
    /* Elements already in the viewport at page-load time (hero content,
       anything above the fold) would otherwise get observed and marked
       .is-revealed before the browser ever paints their hidden state —
       there's no scroll distance for the intersection to change, so the
       transition has nothing to animate from and the reveal is invisible.
       Waiting a frame guarantees the hidden state paints at least once
       first, so the fade/zoom/stagger-in is visible even at the very top
       of the page. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        obs.observe(el);
      });
    });
  }

  /** @param {Element} parent */
  function assignStaggerDelays(parent) {
    Array.prototype.forEach.call(parent.children, function (child) {
      if (!child.hasAttribute('data-reveal-child-init')) {
        child.setAttribute('data-reveal-child-init', '');
        observe(child);
      }
    });
  }

  /** @param {Element} parent */
  function watchForNewChildren(parent) {
    if (!('MutationObserver' in window) || parent.hasAttribute('data-reveal-watched')) return;
    parent.setAttribute('data-reveal-watched', '');
    new MutationObserver(function () {
      assignStaggerDelays(parent);
    }).observe(parent, { childList: true });
  }

  function init() {
    var groups = document.querySelectorAll('[data-reveal="stagger"]');
    groups.forEach(function (parent) {
      assignStaggerDelays(parent);
      watchForNewChildren(parent);
    });

    var targets = document.querySelectorAll('[data-reveal]:not([data-reveal="stagger"]):not(.is-revealed)');
    targets.forEach(observe);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
